import { html, TemplateResult, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';
import globalStyles from './nuvance-article-sidebar-block.global.pcss?inline';

/**
 * The Nuvance Article Sidebar Block component
 * @element nuvance-article-sidebar-block
 *
 * General container for article sidebar blocks.
 *
 * @slot default slot for this element.
 */
@customElement('nuvance-article-sidebar-block')
export class NuvanceArticleSidebarBlock extends LitElement {
  adoptedStyleSheets = new AdoptedStyleSheets(this, {
    globalCSS: globalStyles,
  });

  render(): TemplateResult {
    return html` <slot></slot> `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nuvance-article-sidebar-block': NuvanceArticleSidebarBlock;
  }
}
